export default __webpack_public_path__ + "static/media/Gurpreet.bba06fba.jpeg";